import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Fleet } from "./components/Fleet";
import { QuoteForm } from "./components/QuoteForm";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

const Home = () => (
  <div className="dark min-h-screen bg-[#0A0A0C] text-[#FDFBF7] antialiased overflow-x-hidden">
    <Navbar />
    <main>
      <Hero />
      <Services />
      <Fleet />
      <QuoteForm />
    </main>
    <Footer />
    <WhatsAppButton />
    <Toaster richColors position="top-center" />
  </div>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
